/**
 * The content type of the active state of a stateful toolbar button.
 * This determines what the active state is rendered in.
 */
export var IToolbarButtonActiveContentType;
(function (IToolbarButtonActiveContentType) {
    IToolbarButtonActiveContentType["MODAL"] = "modal";
    IToolbarButtonActiveContentType["HEADLESS"] = "headless";
    IToolbarButtonActiveContentType["HORIZONTAL_MENU"] = "horizontal-menu";
    IToolbarButtonActiveContentType["DROPDOWN"] = "dropdown";
    IToolbarButtonActiveContentType["CONTAINER"] = "container";
})(IToolbarButtonActiveContentType || (IToolbarButtonActiveContentType = {}));
/**
 * The type of a toolbar button.
 * If it is stateless, it will always render the same icon and label.
 * If it is stateful, it will become active when clicked and can have a different icon and label.
 * The active state can be rendered in different ways, depending on the active state content type (activeStateContentType).
 */
export var IToolbarButtonType;
(function (IToolbarButtonType) {
    // Button without an off and on state
    IToolbarButtonType["STATELESS"] = "stateless";
    IToolbarButtonType["STATEFUL"] = "stateful";
})(IToolbarButtonType || (IToolbarButtonType = {}));
/**
 * Ids used for identifying tutorial steps related to
 * toolbar items.
 * ref: https://cloudscape.aws.dev/components/hotspot
 */
export var CustomHotspotIds;
(function (CustomHotspotIds) {
    CustomHotspotIds["PREFERENCES"] = "Preferences";
})(CustomHotspotIds || (CustomHotspotIds = {}));
